import { render } from "./DirectMessagesContent.vue?vue&type=template&id=69741794"
import script from "./DirectMessagesContent.vue?vue&type=script&lang=js"
export * from "./DirectMessagesContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__